export default __webpack_public_path__ + "static/media/banner2.91f53766.jpg";